import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingModule } from '@components/loading/index';
import { CustomPipeModule } from '@components/custom-pipe/custom-pipe.module';
import { DirectivesModule } from '@directives/directives.module';
import { ProductCarouselComponent } from './product-carousel.component';
import {CsIconModule} from '@components/icon';

@NgModule({
    imports: [CommonModule, LoadingModule, DirectivesModule, CustomPipeModule, CsIconModule],
  declarations: [ProductCarouselComponent],
  exports: [ProductCarouselComponent],
})
export class ProductCarouselModule {}
